import { ReportVM } from "./ReportVM";

export class SavedReportDto {
    savedReportId: number;
    reportId: number;
    savedReportName: string;
    comments: string;
    parameters: string;
    isActive: boolean;
    isDeleted: boolean;
    savedBy: number;
    savedOn: string;
    isUpdate: boolean;
};
export class SaveReportInputDto {
    base64string: string;
}
export class SaveReportMainDto {
    instanceId: number;
    startDate: Date;
    endDate: Date;
    weekly: boolean;
    includeMERABooking: boolean;
    tabSelected: string;
    councellor: ReportVM[];
    engagement:ReportVM[];
    resource: ReportVM[];
    serviceLine: ReportVM[];
    subServiceLine: ReportVM[];
    costCentre: ReportVM[];
    competency: ReportVM[];
    // gUI: ReportVM[];
    // gPN: ReportVM[];
    includeDummyResources: boolean | null;
    country: ReportVM[];
    level: ReportVM[];
    grade: ReportVM[];
    rank: ReportVM[];
    employeeStatus: ReportVM[];
    employeeType: ReportVM[];
    companyCode: ReportVM[];
    economicLocation: ReportVM[];
    officeLocation: ReportVM[];
    counsellorName: ReportVM[];
    employeeDepartment: ReportVM[];
    gdsRegionAlignment: ReportVM[];
    availability: number;
    fso: boolean | null;
    region: ReportVM[];
    subRegion: ReportVM[];

    engagementType: ReportVM[];
    // engagementNumber: ReportVM[];
    includeDummyEngagement: boolean | null;
    engagementSubType: ReportVM[];
    engagementCountry: ReportVM[];
    engagementRegion: ReportVM[];
    engagementStatus: ReportVM[];
    engagementManager: ReportVM[];
    engagementPartner: ReportVM[];
    customer: ReportVM[];
    customerIndustry: ReportVM[];
    customerPriorityStatus: ReportVM[];
    ultimateCustomer: ReportVM[];
    bookingCategory: ReportVM[];
    // added for eng
    job_ServiceLine: ReportVM[];
    job_SubServiceLine: ReportVM[];
    job_CostCentre: ReportVM[];
    job_Competency: ReportVM[];

    bookingTypes: ReportVM[];
    bookings: ReportVM[];
    mERAActions: ReportVM[];
    mERABookings: ReportVM[];
    requestors: ReportVM[];
    requestorModes: ReportVM[];
    status: ReportVM[];
    statusInformation: ReportVM[];
    submittedBy: ReportVM[];
    submittedOnStartDate: Date | null;
    submittedOnEndDate: Date | null;
    approvedBy: ReportVM[];
    approvedOnStartDate: Date | null;
    approvedOnEndDate: Date | null;
    rejectedBy: ReportVM[];
    rejectedOnStartDate: Date | null;
    rejectedOnEndDate: Date | null;
}